import CustomerRecords  from "../../../../domain/record/customer/CustomerRecords";
import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_CUSTOMER_RECORDS = "SET_CUSTOMER_RECORDS",
}

export interface SetCustomerRecordsAction extends ResKaReduxAction {
  customerRecords: CustomerRecords;
}

export type CustomerRecordsAction = SetCustomerRecordsAction;

export const setCustomerRecordsAction = (customerRecords: CustomerRecords): SetCustomerRecordsAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_RECORDS,
  customerRecords: customerRecords,
});